// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1518bc22","337":"948f79d5","455":"5c25db03","488":"a81189c2"}[chunkId] + ".chunk.js";
};